import { Component, Input, SimpleChanges, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MessageService } from "projects/core/src/lib/core/MessageService";
import { QuestionModel } from "../../model/QuestionModel";
import { DateValidator } from "./FormControl";


@Component({
  selector: 'component-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent {

  constructor(
    //private formBuilder: FormBuilder,
  ) {}

  questionObj: QuestionModel

  @Input() questionLoading: boolean;
  @Input() disabled: boolean = false;
  @Input() set question(value: QuestionModel) {
    this.questionObj = value
    this.processQuestion()
  }

  @ViewChild("idInputString") idInputString
  @ViewChild("idInputMlString") idInputMlString
  @ViewChild("idInputDate") idInputDate
  @ViewChild("idInputFloat") idInputFloat
  @ViewChild("idInputInteger") idInputInteger
  @ViewChild("idInputEmail") idInputEmail
  @ViewChild("idInputPhone") idInputPhone

  formValue: any
  options = []
  formList = []
  
  form;

  getForm(obj) {
    return JSON.stringify(obj)
  }

  async ngOnInit() {
    //this.onAddSurgeries()
  }

  processQuestion() {
    if (this.questionObj) {

      switch (this.questionObj.type) {
        case "money": {
          this.formValue = this.questionObj.answer || "0,00"
        } break;
        case "boolean": {
          this.formValue = this.questionObj.answer || null
        } break;
        case "options": {
          this.formValue = this.questionObj.answer || null
        } break;
        case "list": {
          if (this.questionObj.extras) {
            this.formList = this.getList(this.questionObj.extras)
            this.formCtrl.controls = []
            
            if (this.questionObj.answer) {
              const itens = JSON.parse(this.questionObj.answer)
              
              itens.forEach((item) => {
                this.addNewItem(item)  
              })

            } else {
              this.addNewItem()
            }
          }
        } break;
        default: {
          this.formValue = this.questionObj.answer || ""
        } break;
      }
    }
  }

  handlerSetFocusInput(type) {
    setTimeout(() => {
      let elInput = this.getElementInput(type)
      //if (elInput) elInput.setFocus()
    }, 1000)
  }

  getElementInput(type) {
    let elInput = null
    switch (type) {
      case "string": {
        elInput = this.idInputString
      } break;
      case "ml_string": {
        elInput = this.idInputMlString
      } break;
      case "birth_date": {
        elInput = this.idInputDate
      } break;
      case "money": {
        elInput = this.idInputFloat
      } break;
      case "integer": {
        elInput = this.idInputInteger
      } break;
      case "email": {
        elInput = this.idInputEmail
      } break;
      case "phone": {
        elInput = this.idInputPhone
      } break;
    }
    return elInput
  }

  handlerKeypressInput(event) {
    if (event.key == "Enter") {
      MessageService.sendMessage(MessageService.KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION)
    }
  }

  getAnswer() {
    let value
    switch (this.questionObj.type) {
      case "birth_date": {
        value = (document.getElementById("idInputDate") as any).value
      } break;
      case "money": {
        value = (document.getElementById("idInputFloat") as any).value
      } break;
      case "percent": {
        value = (document.getElementById("idInputPercent") as any).value
      } break;
      case "phone": {
        value = (document.getElementById("idInputPhone") as any).value
      } break;
      default: {
        value = this.formValue
      } break;
    }
    return this.validateField(this.questionObj.type, value)
  }

  validateField(type, value) {
    switch (type) {
      case "list": {
        let itens = []
        this.formCtrl.controls.forEach((item: any) => {
          let objItem = {}
          const keys = Object.keys(item.controls)
          for (let i = 0; i < keys.length; i++) {
            const field = this.formList.find((item) => {
              return item.label == keys[i]
            })

            const valueField = this.validateField(field.type, item.controls[keys[i]].value)
            objItem[keys[i]] = valueField
          }
          itens.push(objItem)
        })
        value = JSON.stringify(itens)
      } break;
      case "email": {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(value).toLowerCase().trim())) {
          throw Error("Informe um endereço de e-mail válido")
        }
      } break;
      case "phone": {
        if (value == '') {
          throw Error('É necessário preencher com o telefone')
        }
      } break;
      case "birth_date": {
        var re = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
        if (value.length < 10 && !re.test(String(value).toLowerCase().trim())) {
          throw Error("Informe uma data válida")
        } else {
          const dateSplit = value.split("/")
          const currentDate = new Date();
          const dateValue = new Date(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}T00:00:00`);
          currentDate.setHours(0);
          currentDate.setMinutes(0);
          currentDate.setSeconds(0);
          currentDate.setMilliseconds(0);
          const time = currentDate.getTime() - dateValue.getTime()
          const diferrenceDays = time / (1000 * 3600 * 24)
          if (diferrenceDays < 0) {
            throw Error("A data precisa ser menor que hoje")
          } else if (dateValue.getTime() < new Date("1900-01-01T00:00:00").getTime()) {
            throw Error("A data precisa ser maior que a informada")
          }
        }
      } break;
      case "ml_string":
      case "string": {
        if (value == '') {
          throw Error("É necessário preencher o campo com a informação solicitada")
        }
      } break;
      case "boolean": {
        if (value == null) {
          throw Error("É necessário selecionar a opção de sim ou não")
        }
      } break;
    }
    return value
  }

  getOptions(extras: String) {
    const listSplit = extras.split("|")
    return listSplit
  }

  selectOption(value) {
    this.formValue = value
    MessageService.sendMessage(MessageService.KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION)
  }

  btnConfirmAnswer() {
    MessageService.sendMessage(MessageService.KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION)
  }

  btnConfirmFinish() {
    MessageService.sendMessage(MessageService.KEY_CLIENT_PROSPECT_CONFIRM_LAST_QUESTION)
  }

  getList(extras: String) {
    const listSplit = extras.split("|")
    const aux = []
    for (let item of listSplit) {
      const splitColumn: any = item.match(/(.*)\[(.*)\]/)
      const itemObj = {
        label: splitColumn[1],
        type: splitColumn[2],
        value: null
      }
      aux.push(itemObj)
    }
    return aux
  }

  formCtrl = new FormArray([])
  formDate = new FormGroup({
    date: new FormControl({
      value: '',
      disabled: this.disabled
    }, DateValidator.ptDate)
  })

  addNewItem(valueItem = null) {
    const fg = new FormGroup({})
    for (let item of this.formList) {

      let value
      if (valueItem) {
        value = valueItem[item.label]
      }

      switch (item.type) {
        case 'boolean': {
          fg.addControl(item.label, new FormControl({
            value: value || null,
            disabled: this.disabled
          }, Validators.required))
        } break;
        case 'birth_date': {
          fg.addControl(item.label, new FormControl({
            value: value || "",
            disabled: this.disabled
          }, DateValidator.ptDate))
        } break;
        case 'money': {
          fg.addControl(item.label, new FormControl({
            value: value || "0,00",
            disabled: this.disabled
          }, Validators.required))
        } break;
        default: {
          fg.addControl(item.label, new FormControl({
            value: value || "",
            disabled: this.disabled
          }, Validators.required))
        } break;
      }
    }
    try {
      this.validateField('list', null)
      this.formCtrl.push(fg)
    } catch(e) {
      alert(e.message)
    }
  }

  removeItem(index) {
    this.formCtrl.controls.splice(index, 1)
  }

  selectOptionList(index, field, value) {
    const obj = Object.assign(this.formCtrl.controls[index].value)
    obj[field] = value
    this.formCtrl.controls[index].setValue(obj)
  }
}
